import { FC, Fragment } from "react";
import { ImageLogoLogin } from "../atoms/ImageLogoLogin";
import { LinkLogin } from "../atoms/LinkLogin";

export type HeaderLoginProps = {
  src: string;
  h2Text: string;
  pText: string;
  aText: string;
  href: string;
  className?: string; // Añadir className como prop opcional
};

export const HeaderLogin: FC<HeaderLoginProps> = ({
  src,
  h2Text,
  pText,
  aText,
  href,
  className,
}) => {
  return (
    <Fragment>
      <div className={className}>
        <ImageLogoLogin company="" src={src} />
        <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
          {h2Text}
        </h2>

        <p className="mt-2 text-sm leading-6 text-gray-500">
          {pText} <LinkLogin texto={aText} />
        </p>
      </div>
    </Fragment>
  );
};
